


































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class ConfirmDialog extends Vue {
  @Prop()
  private model: any;
  @Prop()
  private visible: boolean | undefined;
  private versions: any[] = [];
  private info: any = {};
  private visibleChange() {
    this.$emit("update:visible", this.visible);
  }
  private get ifVisible() {
    return this.visible ? this.visible : false;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  /**
   * @description 获取当前模板的版本列表
   */
  private fetchVersions() {
    const params: any = {
      params: {
        model_id: this.model.model_id
      }
    };
    axios.get("api/model/versions", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.versions = data.data.versions;
      });
    });
  }
  /**
   * @description 取消
   */
  private cancel() {
    this.$emit("update:visible", false);
  }
  /**
   * @description 确定
   */
  private confirm() {
    this.$message.success("申请成功");
    this.$emit("update:visible", false);
  }
  private mounted() {
    this.fetchVersions();
  }
}
